import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  forwardRef,
  inject,
  Input,
  OnInit,
  TemplateRef
} from '@angular/core';
import {MatExpansionPanel, MatExpansionPanelHeader} from '@angular/material/expansion';
import {FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {NgTemplateOutlet} from '@angular/common';

@Component({
  selector: 'pas-choise',
  standalone: true,
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    ReactiveFormsModule,
    NgTemplateOutlet
  ],
  templateUrl: './choise.component.html',
  styleUrl: './choise.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChoiseComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChoiseComponent<T extends { id: number, name: string }> implements OnInit {
  @ContentChild('name', {static: true, read: TemplateRef}) name: TemplateRef<any>|null = null;
  _items: T[] = []
  @Input({}) set items(v: T[]){
    this._items = v;

    // !this.form.get('value')?.value && this.form.get('value')?.setValue(this._items[0],{emitEvent: false});
  }
  @Input() title: string = ''

  cdr = inject(ChangeDetectorRef);

  openedPanel = true

  private onChange = (_: any) => {
  };
  public onTouched = () => {
  };

  form = new FormGroup({
    value: new FormControl<T | null>(null),
  })

  get value(): T | null {
    const res= this.form.get('value')!.value as T
    return res;
  }

  writeValue(value: T): void {
    if (value) {
      this.form.get('value')?.setValue(value);
    } else {
      this.form.get('value')?.setValue(null);
    }
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  ngOnInit(): void {
    this.form.get('value')?.valueChanges.subscribe(value => {
      this.onChange(value);
    })
  }


}
